import styled from "styled-components";

export const StyledBarcodePage = styled.div``;